import { toast as sonnerToast } from 'sonner'

/**
 * Verifica se é um erro de rede quando offline
 */
function isOfflineNetworkError(error: unknown): boolean {
  if (navigator.onLine) return false
  
  const errorObj = error as any
  if (errorObj?.code === 'ERR_NETWORK') return true
  if (errorObj?.message?.includes('Network Error')) return true
  if (errorObj?.message?.includes('Failed to fetch')) return true
  
  return false
}

/**
 * Wrapper para toast.error que não exibe quando offline com erro de rede
 */
function errorToast(message: string, error?: unknown) {
  // Não mostra toast se:
  // 1. Mensagem vazia
  // 2. Está offline e é erro de rede
  if (!message || message.trim() === '') {
    return
  }
  
  if (error && isOfflineNetworkError(error)) {
    return
  }
  
  if (!navigator.onLine && (
    message.includes('Network') || 
    message.includes('offline') ||
    message.includes('conexão')
  )) {
    return
  }
  
  sonnerToast.error(message)
}

/**
 * Toast customizado que respeita o estado offline
 */
export const toast = {
  success: sonnerToast.success,
  error: errorToast,
  info: sonnerToast.info,
  warning: sonnerToast.warning,
  promise: sonnerToast.promise,
  loading: sonnerToast.loading,
  custom: sonnerToast.custom,
  message: sonnerToast.message,
  dismiss: sonnerToast.dismiss,
}
